import Vue from "vue";
import App from "./App.vue";
import api from "./api";
// 引入指令
import Directive from "@/directive";

Vue.config.productionTip = false;

// 挂载到 Vue 原型
Vue.prototype.$api = api;
Vue.use(Directive);
new Vue({
  render: (h) => h(App),
}).$mount("#app");
